const BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const error = new Error((data && data.error) || 'Request failed');
    error.status = res.status;
    throw error;
  }

  return data;
}

export const adminApi = {
  login: (username, password) =>
    request('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
  logout: () => request('/auth/logout', { method: 'POST' }),
  me: () => request('/auth/me'),
  forgotPassword: (username, recoveryCode, newPassword) =>
    request('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ username, recoveryCode, newPassword }) }),
  changePassword: (currentPassword, newPassword) =>
    request('/admin/change-password', { method: 'POST', body: JSON.stringify({ currentPassword, newPassword }) }),
  generateRecoveryCode: () => request('/admin/recovery-code', { method: 'POST' }),
  listPosts: () => request('/admin/posts'),
  getPost: (id) => request(`/admin/posts/${id}`),
  createPost: (payload) => request('/admin/posts', { method: 'POST', body: JSON.stringify(payload) }),
  updatePost: (id, payload) => request(`/admin/posts/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deletePost: (id) => request(`/admin/posts/${id}`, { method: 'DELETE' }),

  listMessages: () => request('/admin/messages'),
  deleteMessage: (id) => request(`/admin/messages/${id}`, { method: 'DELETE' }),

  listSubscribers: () => request('/admin/subscribers'),

  listUsers: () => request('/admin/users'),
  createUser: (username, password) =>
    request('/admin/users', { method: 'POST', body: JSON.stringify({ username, password }) }),
  deleteUser: (id) => request(`/admin/users/${id}`, { method: 'DELETE' }),

  listContent: (type) => request(`/admin/content?type=${type}`),
  createContent: (payload) => request('/admin/content', { method: 'POST', body: JSON.stringify(payload) }),
  updateContent: (id, payload) => request(`/admin/content/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deleteContent: (id) => request(`/admin/content/${id}`, { method: 'DELETE' }),
};

export const publicApi = {
  listPosts: () => request('/posts'),
  getPost: (slug) => request(`/posts/${slug}`),
  listContent: (type) => request(`/content?type=${type}`),
};
